/**
 * 用户选择器
 */
import * as React from 'react';
import { Select } from 'antd';
import { useState, useEffect } from 'react';
import { getUserByRole, getUserOfCompanyByRoles } from '@/api/cascade';
import _ from 'lodash';

interface UserByroleSelectProps {
  value?: string | null;
  onChange?: (value: string | undefined) => void;
  // 当前用户
  userAccount?: string;
  [key: string]: any;
}

interface User {
  userAccount: string;
  userName: string;
  id: number;
}

const UserByroleSelect: React.FC<UserByroleSelectProps> = (props) => {
  const {
    value,
    onChange,
    roleNumbers,
    userAccount,
    ...otherProps
  } = props;

  const [options, setOptions] = useState<any[]>([]);

  const getInit = async () => {
    try {
      let allUser: User[] = [];
      // 若userAccount存在则查询与userAccount在同一二级组织（公司）的指定角色的用户
      if (userAccount) {
        allUser = await getUserOfCompanyByRoles(roleNumbers, userAccount);
      } else {
        // 否则只查询指定角色的用户
        const resList = await Promise.all(roleNumbers?.map((roleNumber: string) => {
          return getUserByRole({ roleNumber, userAccount });
        }));
        resList.forEach((itemList: any) => {
          itemList.forEach((el: any) => {
            const preEl = allUser.find((item: any) => item.userAccount === el.userAccount);
            if (!preEl) {
              allUser.push(el);
            }
          });
        });
      }

      const list = allUser.map((user: User) => ({
        value: user.userAccount,
        label: user.userName,
      }));
      setOptions(list);
    } catch (error) {
      console.error(error);
      setOptions([]);
    }
  };

  useEffect(() => {
    getInit();
  }, [roleNumbers, userAccount]);

  const _onChange = (key?: string) => {
    onChange?.(key);
  };

  return (
    <>
      <Select showSearch optionFilterProp="children" {...otherProps} value={value} onChange={_onChange}>
        {options.map((item: any) => (
          <Select.Option key={item.value} value={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    </>
  );
};
export default UserByroleSelect;
